import { render, staticRenderFns } from "./drawing-form.vue?vue&type=template&id=a5d0bba2"
import script from "./drawing-form.vue?vue&type=script&lang=js"
export * from "./drawing-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports